var Autogrow = Backbone.View.extend({
    initialize: function (options) {
        this.minHeight = options.minHeight || 10;
        this.manualDetect = !!options.manualDetect;
        this.manualTrigger = !!options.manualTrigger;

        this.renderShim();
    },
    events: {
        'input': 'onInput',
        'keyup': 'onInput',
        'update': 'onInput'
    },
    onInput: function (e) {
        if (!this.manualDetect) {
            this.resize();
        }
    },
    renderShim: function () {
        this.shim = $('<div class="shim">');
        $('#inputShims').append(this.shim);
    },
    isGrown: function () {
        return this.$el.height() > this.minHeight + 5;
    },
    resize: function () {
        // Copy value to shim and get dimensions. triggers style recalculate
        this.shim.width(this.$el.width());
        var value = this.$el.val()
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#x27;')
            .replace(/\//g, '&#x2f;');
        this.shim.html(value + '\n');
        // Recalculates styles
        var newHeight = Math.max(this.shim.height(), this.minHeight);
        
        // Only if the height changes
        if (newHeight !== this.currentHeight) {
            this.currentHeight = newHeight;
            // Limit the height to half the window
            var overflow = 'hidden';
            var halfWindowHeight = $(window).height() / 2;
            if (newHeight > halfWindowHeight) {
                newHeight = halfWindowHeight;
                overflow = 'auto';
            }
            var css = {
                'height': newHeight,
                'overflow': overflow
            };
            if (this.manualTrigger) {
                this.$el.trigger('autogrow', css);
            } else {
                this.$el.css(css);
            }
        }
    }
});


module.exports = Autogrow;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/autogrow.js
// module id = ZGvr
// module chunks = 1